export default __webpack_public_path__ + "static/media/plus.cc379304.svg";